import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
 
// import required modules
import SwiperCore, { FreeMode, Navigation, Thumbs, Autoplay } from "swiper";

import * as apiUrl from "../../apiUrl";

SwiperCore.use([FreeMode, Navigation, Thumbs, Autoplay]);

function CommunityInnerpageFeature({sectionTitle, features}) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [CommunityFeatures, setCommunityFeatures] = useState({});
 
  const Slidecontents = features.slide_content
    ? JSON.parse(features.slide_content)
    : [];

  const Slidethumbs = features.slide_thumb_images
    ? JSON.parse(features.slide_thumb_images)
    : [];

  return ( 
      <div className="home-community-sec">
 
        <Container fluid className="home-community-container">
          <Row>
            <Col md={12}>
              <div className="home-community-swiper">
                <Swiper
                  loop={false}
                  spaceBetween={20}
                  autoplay={true}
                  speed={1000}
                  // navigation={true}
                  thumbs={{
                    swiper:
                      thumbsSwiper && !thumbsSwiper.destroyed
                        ? thumbsSwiper
                        : null,
                  }}
                  modules={[FreeMode, Navigation, Thumbs]}
                  className="mySwiper2"
                >
                  {Slidecontents.map((Slidecontent, index) => (
                    <SwiperSlide key={index}>
                      <Row>
                        <Col md={12}>
                          <div
                            className="home-community-head commu-feature-div"
                            data-aos="fade-right"
                          >
                            <h1
                              className="common-head goldenColor"
                              data-aos="fade-right"
                            >
                              {sectionTitle}
                            </h1>
                            <p className="common-para" data-aos="fade-right">
                              {Slidecontent.feature_description}
                            </p>                           
                            <span className="marquis-golden-text">
                              {Slidecontent.feature_name}
                            </span>
                          </div>
                        </Col>
                      </Row>{" "}
                      <img
                        src={`${apiUrl.apiUrl}/${Slidecontent.slide_image}`}
                        className="img-fluid"
                        alt="community-image"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
                <Swiper
                  onSwiper={setThumbsSwiper}
                  loop={false}
                  autoplay={true}
                  speed={1000}
                  spaceBetween={20}
                  slidesPerView={7}
                  freeMode={true}
                  watchSlidesProgress={true}
                  modules={[FreeMode, Navigation, Thumbs]}
                  breakpoints={{
                    240: { slidesPerView: 4, spaceBetween: 10 },
                    320: { slidesPerView: 4, spaceBetween: 10 },
                    420: { slidesPerView: 4, spaceBetween: 10 },
                    768: { slidesPerView: 4, spaceBetween: 10 },
                    1024: { slidesPerView: 6 },
                    1280: { slidesPerView: 7 },
                  }}
                  className="mySwiper"
                >
                  {Slidethumbs.map((Slidethumb, index) => (
                    <SwiperSlide key={index}>
                      {" "}
                      <img
                        src={`${apiUrl.apiUrl}/${Slidethumb.slide_thumb_image}`}
                        className="img-fluid"
                        alt="community-image"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </Col>
          </Row>
        </Container>
      </div> 
  );
}

export default CommunityInnerpageFeature;
